import axiosInstance from '../lib/axios-instance';

export interface IPaymentSettings {
  emailPaymentMethods: number[];
  letterPaymentMethods: number[];
  manualPaymentMethod: number[];
}

export const getGlobalPaymentSettings = async (): Promise<IPaymentSettings> => {
  try {
    const res = await axiosInstance.get('settings/global/refund-portal');
    return res.data;
  } catch (error) {
    throw new Error('Failed to get payment settings');
  }
};

export const getFacilityPaymentSettings =
  async (): Promise<IPaymentSettings> => {
    try {
      const res = await axiosInstance.get(`settings/facility/refund-portal`);
      return res.data;
    } catch (error) {
      throw new Error('Failed to get payment settings');
    }
  };
